import * as React from 'react';

function SvgArrowRightInCircle(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.196 18.523a.411.411 0 00.008.537.317.317 0 00.482-.01l3.518-4.054a.412.412 0 000-.529l-3.518-4.051a.317.317 0 00-.482-.01.411.411 0 00-.008.538l3.288 3.788-3.288 3.79z"
        fill="#414B56"
      />
      <circle cx={15} cy={15} r={10.5} stroke="#414B56" />
    </svg>
  );
}

export default SvgArrowRightInCircle;
